/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, themeV2 } from '@insticator/insticator-ui'; // iui-utils


/* ++++++++++ --------------- EXPORT : COMMENTS COUNTER SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  commentscountersection: {
    marginTop: pxToEm(16),
    '& .collapsable.opened': {
      maxHeight: pxToEm(3000)
    },
    '& .name-commentscounterlabels': {
      marginTop: pxToEm(16),
      '& .gridset': { gap: pxToEm(12) }
    },
    '& label': {
      color: themeV2.color.primary.main,
      fontWeight: 700,
      marginBottom: pxToEm(8)
    }
  }
});
